<template>
    <Overlay :showOverlay="show" :video="true" :clearBg="true" @close="show = !show" title="title">
        <template v-slot:content>
            <div class="overlay__video-player-wrapper">
                <iframe scrolling="no" :src="podcastEmbedUrl" width="100%" height="200" frameborder="no"></iframe>
            </div>
        </template>
    </Overlay>
</template>

<script>
import Overlay from "../Global/Overlay.vue"

import VuePlyr from '@skjnldsv/vue-plyr'
import '@skjnldsv/vue-plyr/dist/vue-plyr.css'

export default {
    props: ["componentId", "secondComponentId", "podcastEmbedUrl", "container", "showDefault"],
    components: {
        Overlay,
        VuePlyr
    },
    data() {
        return {
            show: false,
            url: "",
        }
    },
    mounted() {
        let self = this;
        document.getElementById(this.componentId).addEventListener("TogglePodcastOverlay", (e) => {
            self.toggleOverlay();
        });
        if (this.secondComponentId) {
            document.getElementById(this.secondComponentId).addEventListener("TogglePodcastOverlay", (e) => {
                self.toggleOverlay();
            });
        }
    },
    methods: {
        toggleOverlay: function () {
            this.show = !this.show;

        },
    }
}
</script>
